{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "HEADER": "Shopify",
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "取消",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "集成设置",
    "DESCRIPTION": "Chatwoot 集成了多种工具和服务，以提高团队效率。浏览以下列表以配置您喜欢的应用程序。",
    "LEARN_MORE": "了解更多关于集成的信息",
    "LOADING": "正在获取集成",
    "SEARCH_PLACEHOLDER": "Search integrations...",
    "NO_RESULTS": "No integrations found matching your search",
    "CAPTAIN": {
      "DISABLED": "您的账户未启用 Captain。",
      "CLICK_HERE_TO_CONFIGURE": "点击此处配置",
      "LOADING_CONSOLE": "正在加载 Captain 控制台……",
      "FAILED_TO_LOAD_CONSOLE": "加载 Captain 控制台失败。请刷新页面并重试。"
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "订阅事件",
      "LEARN_MORE": "了解更多关于 Webhooks 的信息",
      "PAYWALL": {
        "TITLE": "Webhooks are available on paid plans",
        "AVAILABLE_ON": "Use webhooks to receive real-time events from your Chatwoot account.",
        "UPGRADE_PROMPT": "Upgrade to the Startups, Business, or Enterprise plan to use webhooks.",
        "UPGRADE_NOW": "立即升级",
        "CANCEL_ANYTIME": "Change or cancel your plan anytime."
      },
      "SECRET": {
        "LABEL": "Secret",
        "COPY": "Copy secret to clipboard",
        "COPY_SUCCESS": "Secret copied to clipboard",
        "TOGGLE": "Toggle secret visibility",
        "CREATED_DESC": "Your webhook has been created. Use the secret below to verify webhook signatures. Please copy it now — you can also find it later in the webhook edit form.",
        "DONE": "Done"
      },
      "COUNT": "{n} webhook | {n} webhooks",
      "SEARCH_PLACEHOLDER": "Search webhooks...",
      "NO_RESULTS": "No webhooks found matching your search",
      "FORM": {
        "CANCEL": "取消",
        "DESC": "Webhook 事件为您提供了有关 Chatwoot 账户中发生的事情的实时信息。请输入一个有效的 URL 来配置回调。",
        "SUBSCRIPTIONS": {
          "LABEL": "事件",
          "EVENTS": {
            "CONVERSATION_CREATED": "对话创建",
            "CONVERSATION_STATUS_CHANGED": "对话状态已更改",
            "CONVERSATION_UPDATED": "对话已更新",
            "MESSAGE_CREATED": "消息已创建",
            "MESSAGE_UPDATED": "消息已更新",
            "WEBWIDGET_TRIGGERED": "用户打开实时聊天小部件",
            "CONTACT_CREATED": "联系人已创建",
            "CONTACT_UPDATED": "联系人已更新",
            "CONVERSATION_TYPING_ON": "对话输入开启",
            "CONVERSATION_TYPING_OFF": "对话输入关闭",
            "INBOX_UPDATED": "Inbox updated"
          }
        },
        "NAME": {
          "LABEL": "Webhook Name",
          "PLACEHOLDER": "Enter the name of the webhook"
        },
        "END_POINT": {
          "LABEL": "Webhook 网址",
          "PLACEHOLDER": "例如：{webhookExampleURL}",
          "ERROR": "请输入一个有效的 URL"
        },
        "EDIT_SUBMIT": "更新 Webhook",
        "ADD_SUBMIT": "创建 Webhook"
      },
      "TITLE": "回调接口地址",
      "CONFIGURE": "配置",
      "HEADER": "Webhook 设置",
      "HEADER_BTN_TXT": "添加新的 Webhook",
      "LOADING": "正在获取已添加的 Webhooks",
      "SEARCH_404": "没有任何项目符合此查询",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>Webhooks 是 HTTP 回调，可以为每个账户定义。它们由诸如在 Chatwoot 中创建消息等事件触发。您可以为此账户创建多个 Webhooks。<br /><br /> 要创建一个 <b>Webhook</b>，点击 <b>添加新的 Webhook</b> 按钮。您也可以通过点击删除按钮删除任何现有的 Webhook。</p>",
      "LIST": {
        "404": "此账户没有配置 Webhooks。",
        "TITLE": "管理 Webhooks",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Webhook 端点",
          "ACTIONS": "操作"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "编辑",
        "TITLE": "编辑 Webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook 配置更新成功",
          "ERROR_MESSAGE": "无法连接服务器，请稍后再试"
        }
      },
      "ADD": {
        "CANCEL": "取消操作",
        "TITLE": "添加新的 Webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook 配置添加成功",
          "ERROR_MESSAGE": "无法连接服务器，请稍后再试"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "删除",
        "API": {
          "SUCCESS_MESSAGE": "Webhook 删除成功",
          "ERROR_MESSAGE": "无法连接服务器，请稍后再试"
        },
        "CONFIRM": {
          "TITLE": "确认删除",
          "MESSAGE": "您确定要删除该 Webhook 吗？({webhookURL})",
          "YES": "是，删除",
          "NO": "否，保留它"
        }
      }
    },
    "SLACK": {
      "HEADER": "Slack",
      "DELETE": "删除",
      "DELETE_CONFIRMATION": {
        "TITLE": "删除集成",
        "MESSAGE": "您确定要删除该集成吗？这样做将导致您无法在 Slack 工作区中访问对话。"
      },
      "HELP_TEXT": {
        "TITLE": "使用 Slack 集成？",
        "BODY": "通过此集成，所有传入的对话将同步到您的 Slack 工作区中的 ***{selectedChannelName}*** 频道。您可以直接在频道中管理所有客户对话，再也不会错过任何消息。\n\n以下是该集成的主要功能：\n\n**从 Slack 回复对话：** 要在 ***{selectedChannelName}*** Slack 频道中回复对话，只需输入您的消息并将其作为线程发送。这将通过 Chatwoot 创建对客户的回复。就是这么简单！\n\n**创建私密笔记：** 如果您想创建私密笔记而不是回复，请在消息开头加上 ***`note:`***。这将确保您的消息保持私密，不会对客户可见。\n\n**关联客服资料：** 如果在 Slack 上回复的人拥有与 Chatwoot 中相同电子邮件的客服资料，回复将自动与该客服资料关联。这意味着您可以轻松跟踪谁在何时说了什么。另一方面，如果回复者没有关联的客服资料，回复将显示为机器人资料。",
        "SELECTED": "已选择"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "选择一个频道",
        "UPDATE": "更新",
        "BUTTON_TEXT": "连接频道",
        "DESCRIPTION": "您的 Slack 工作区现已与 Chatwoot 连接。但是，集成当前处于非活动状态。要激活集成并将频道连接到 Chatwoot，请点击下面的按钮。\n\n**注意：** 如果您尝试连接私有频道，请在进行此步骤之前将 Chatwoot 应用添加到 Slack 频道。",
        "ATTENTION_REQUIRED": "需要关注",
        "EXPIRED": "您的 Slack 集成已过期。要继续在 Slack 上接收消息，请删除该集成并重新连接您的工作区。"
      },
      "UPDATE_ERROR": "更新集成时出错，请重试",
      "UPDATE_SUCCESS": "频道连接成功",
      "FAILED_TO_FETCH_CHANNELS": "获取 Slack 频道时出错，请重试"
    },
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "点击此处加入",
      "LEAVE_THE_ROOM": "离开房间",
      "START_VIDEO_CALL_HELP_TEXT": "与客户开始新的视频通话",
      "JOIN_ERROR": "加入通话时出错，请重试",
      "CREATE_ERROR": "创建会议链接时出错，请重试"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI 助手",
      "WITH_AI": " 使用 AI {option} ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "回复建议",
        "SUMMARIZE": "总结",
        "REPHRASE": "改进写作",
        "FIX_SPELLING_GRAMMAR": "修正拼写和语法",
        "SHORTEN": "缩短",
        "EXPAND": "扩展",
        "MAKE_FRIENDLY": "将消息语气改为友好",
        "MAKE_FORMAL": "使用正式语气",
        "SIMPLIFY": "简化",
        "CONFIDENT": "Use confident tone",
        "PROFESSIONAL": "Use professional tone",
        "CASUAL": "Use casual tone",
        "STRAIGHTFORWARD": "Use straightforward tone"
      },
      "REPLY_OPTIONS": {
        "IMPROVE_REPLY": "Improve reply",
        "IMPROVE_REPLY_SELECTION": "Improve the selection",
        "CHANGE_TONE": {
          "TITLE": "Change tone",
          "OPTIONS": {
            "PROFESSIONAL": "专业",
            "CASUAL": "Casual",
            "STRAIGHTFORWARD": "Straightforward",
            "CONFIDENT": "Confident",
            "FRIENDLY": "友好"
          }
        },
        "GRAMMAR": "Fix grammar & spelling",
        "SUGGESTION": "Suggest a reply",
        "SUMMARIZE": "Summarize the conversation",
        "ASK_COPILOT": "Ask Copilot"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "草稿内容",
        "GENERATED_TITLE": "生成内容",
        "AI_WRITING": "AI 正在写作",
        "BUTTONS": {
          "APPLY": "使用此建议",
          "CANCEL": "取消"
        }
      },
      "CTA_MODAL": {
        "TITLE": "集成 OpenAI",
        "DESC": "通过 OpenAI 的 GPT 模型为您的仪表板带来高级 AI 功能。要开始，请输入您 OpenAI 账户的 API 密钥。",
        "KEY_PLACEHOLDER": "输入您的 OpenAI API 密钥",
        "BUTTONS": {
          "NEED_HELP": "需要帮助？",
          "DISMISS": "取消",
          "FINISH": "完成设置"
        },
        "DISMISS_MESSAGE": "您可以稍后随时设置 OpenAI 集成。",
        "SUCCESS_MESSAGE": "OpenAI 集成设置成功"
      },
      "TITLE": "通过 AI 改进",
      "SUMMARY_TITLE": "通过 AI 总结",
      "REPLY_TITLE": "通过 AI 回复建议",
      "SUBTITLE": "将根据您的当前草稿生成改进的回复。",
      "TONE": {
        "TITLE": "语气",
        "OPTIONS": {
          "PROFESSIONAL": "专业",
          "FRIENDLY": "友好"
        }
      },
      "BUTTONS": {
        "GENERATE": "生成",
        "GENERATING": "生成中...",
        "CANCEL": "取消"
      },
      "GENERATE_ERROR": "处理内容时出错，请重试"
    },
    "DELETE": {
      "BUTTON_TEXT": "删除",
      "API": {
        "SUCCESS_MESSAGE": "集成已成功删除"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "连接"
    },
    "DASHBOARD_APPS": {
      "TITLE": "仪表板应用",
      "HEADER_BTN_TXT": "添加新的仪表板应用",
      "SIDEBAR_TXT": "<p><b>仪表板应用</b></p><p>仪表板应用允许组织将应用程序嵌入 Chatwoot 仪表板中，以便为客服人员提供上下文信息。此功能允许您独立创建应用程序并将其嵌入仪表板中，以提供用户信息、他们的订单或以前的付款历史记录。</p><p>当您使用 Chatwoot 仪表板嵌入应用程序时，您的应用程序将作为窗口事件获取对话和联系人的上下文信息。在您的页面上实现消息事件的监听器以接收上下文信息。</p><p>要添加新的仪表板应用，请点击“添加新的仪表板应用”按钮。</p>",
      "DESCRIPTION": "仪表板应用允许组织将应用程序嵌入仪表板中，以便为客服人员提供上下文信息。此功能允许您独立创建应用程序并将其嵌入仪表板中，以提供用户信息、他们的订单或以前的付款历史记录。",
      "LEARN_MORE": "了解更多关于仪表板应用的信息",
      "COUNT": "{n} dashboard app | {n} dashboard apps",
      "SEARCH_PLACEHOLDER": "Search dashboard apps...",
      "NO_RESULTS": "No dashboard apps found matching your search",
      "LIST": {
        "404": "此账户尚未配置任何仪表板应用",
        "LOADING": "正在获取仪表板应用...",
        "TABLE_HEADER": {
          "NAME": "姓名",
          "ENDPOINT": "端点",
          "ACTIONS": "操作"
        },
        "EDIT_TOOLTIP": "编辑应用",
        "DELETE_TOOLTIP": "删除应用"
      },
      "FORM": {
        "TITLE_LABEL": "姓名",
        "TITLE_PLACEHOLDER": "输入您的仪表板应用的名称",
        "TITLE_ERROR": "仪表板应用的名称是必需的",
        "URL_LABEL": "端点",
        "URL_PLACEHOLDER": "输入您的应用托管的端点 URL",
        "URL_ERROR": "需要有效的 URL"
      },
      "CREATE": {
        "HEADER": "添加新的仪表板应用",
        "FORM_SUBMIT": "提交",
        "FORM_CANCEL": "取消",
        "API_SUCCESS": "仪表板应用配置成功",
        "API_ERROR": "无法创建应用，请稍后重试"
      },
      "UPDATE": {
        "HEADER": "编辑仪表板应用",
        "FORM_SUBMIT": "更新",
        "FORM_CANCEL": "取消",
        "API_SUCCESS": "仪表板应用更新成功",
        "API_ERROR": "无法更新应用，请稍后重试"
      },
      "DELETE": {
        "CONFIRM_YES": "是，删除它",
        "CONFIRM_NO": "否，保留它",
        "TITLE": "确认删除",
        "MESSAGE": "您确定要删除该应用 - {appName} 吗？",
        "API_SUCCESS": "仪表板应用删除成功",
        "API_ERROR": "无法删除应用，请稍后重试"
      }
    },
    "LINEAR": {
      "HEADER": "Linear",
      "ADD_OR_LINK_BUTTON": "创建/链接 Linear 问题",
      "LOADING": "正在获取 Linear 问题...",
      "LOADING_ERROR": "获取 Linear 问题时出错，请重试",
      "CREATE": "创建",
      "LINK": {
        "SEARCH": "搜索问题",
        "SELECT": "选择问题",
        "TITLE": "链接",
        "EMPTY_LIST": "未找到 Linear 问题",
        "LOADING": "加载中",
        "ERROR": "获取 Linear 问题时出错，请重试",
        "LINK_SUCCESS": "问题链接成功",
        "LINK_ERROR": "链接问题时出错，请重试",
        "LINK_TITLE": "对话 (#{conversationId}) 与 {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "创建/链接 Linear 问题",
        "DESCRIPTION": "从对话中创建 Linear 问题，或链接现有问题以进行无缝跟踪。",
        "FORM": {
          "TITLE": {
            "LABEL": "标题",
            "PLACEHOLDER": "输入标题",
            "REQUIRED_ERROR": "标题是必填项"
          },
          "DESCRIPTION": {
            "LABEL": "描述",
            "PLACEHOLDER": "输入描述"
          },
          "TEAM": {
            "LABEL": "团队",
            "PLACEHOLDER": "选择团队",
            "SEARCH": "搜索团队",
            "REQUIRED_ERROR": "团队是必填项"
          },
          "ASSIGNEE": {
            "LABEL": "负责人",
            "PLACEHOLDER": "选择负责人",
            "SEARCH": "搜索负责人"
          },
          "PRIORITY": {
            "LABEL": "优先级",
            "PLACEHOLDER": "选择优先级",
            "SEARCH": "搜索优先级"
          },
          "LABEL": {
            "LABEL": "标签",
            "PLACEHOLDER": "选择标签",
            "SEARCH": "搜索标签"
          },
          "STATUS": {
            "LABEL": "状态",
            "PLACEHOLDER": "选择状态",
            "SEARCH": "搜索状态"
          },
          "PROJECT": {
            "LABEL": "项目",
            "PLACEHOLDER": "选择项目",
            "SEARCH": "搜索项目"
          }
        },
        "CREATE": "创建",
        "CANCEL": "取消",
        "CREATE_SUCCESS": "问题创建成功",
        "CREATE_ERROR": "创建问题时出错，请重试",
        "LOADING_TEAM_ERROR": "获取团队时出错，请重试",
        "LOADING_TEAM_ENTITIES_ERROR": "获取团队实体时出错，请重试"
      },
      "ISSUE": {
        "STATUS": "状态",
        "PRIORITY": "优先级",
        "ASSIGNEE": "负责人",
        "LABELS": "标签",
        "CREATED_AT": "创建于 {createdAt}"
      },
      "UNLINK": {
        "TITLE": "取消链接",
        "SUCCESS": "问题取消链接成功",
        "ERROR": "取消链接问题时出错，请重试"
      },
      "NO_LINKED_ISSUES": "No linked issues found",
      "DELETE": {
        "TITLE": "您确定要删除该集成吗？",
        "MESSAGE": "您确定要删除该集成吗？",
        "CONFIRM": "是，删除",
        "CANCEL": "取消"
      },
      "CTA": {
        "TITLE": "连接到 Linear",
        "AGENT_DESCRIPTION": "Linear 工作区未集成。请通知您的管理员连接一个工作区来使用这个集成。",
        "DESCRIPTION": "Linear workspace is not connected. Click the button below to connect your workspace to use this integration.",
        "BUTTON_TEXT": "链接 Linear 工作空间"
      }
    },
    "NOTION": {
      "HEADER": "Notion",
      "DELETE": {
        "TITLE": "Are you sure you want to delete the Notion integration?",
        "MESSAGE": "Deleting this integration will remove access to your Notion workspace and stop all related functionality.",
        "CONFIRM": "是的，删除",
        "CANCEL": "取消"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "了解更多",
    "OVERVIEW": {
      "HEADER": "概览",
      "WELCOME": {
        "LABEL": "Captain summary",
        "LOADING": "Generating summary…"
      },
      "INBOX_BANNER": {
        "TEXT": "This assistant isn't connected to any inbox yet, so it won't respond to conversations.",
        "ACTION": "Connect inbox",
        "DISMISS": "取消"
      },
      "COVERAGE_BANNER": {
        "TEXT": "{count} FAQs are pending review, keeping coverage at {coverage}%. Approve them so your assistant can resolve more on its own.",
        "ACTION": "Review FAQs",
        "DISMISS": "取消"
      },
      "RANGES": {
        "LAST_DAYS": "Last {count} days",
        "THIS_MONTH": "This month",
        "LAST_MONTH": "Last month"
      },
      "METRICS": {
        "HANDLED": {
          "LABEL": "Conversations handled",
          "HINT": "Distinct conversations this assistant replied in."
        },
        "AUTO_RESOLUTION": {
          "LABEL": "Auto-resolution rate",
          "HINT": "Share of handled conversations closed without a human reply."
        },
        "HANDOFF": {
          "LABEL": "Handoff rate",
          "HINT": "Share of handled conversations escalated to a human agent."
        },
        "HOURS_SAVED": {
          "LABEL": "Time saved",
          "HINT": "Estimate: Captain replies times ~2 minutes of assumed agent effort per reply. Directional, not measured labor."
        },
        "REOPEN": {
          "LABEL": "Reopen rate",
          "HINT": "Auto-resolved conversations that were reopened afterwards."
        },
        "DEPTH": {
          "LABEL": "Messages / conversation",
          "HINT": "Average replies the assistant sends per conversation."
        }
      },
      "DRILLDOWN": {
        "CLOSE": "Close details",
        "EMPTY": "No records found for this metric.",
        "ERROR": "Could not load records. Please try again.",
        "LOAD_MORE": "加载更多",
        "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations"
      },
      "KNOWLEDGE": {
        "TITLE": "Knowledge coverage",
        "COVERAGE": "{pct}% approved",
        "APPROVED": "Approved FAQs",
        "PENDING": "Pending FAQs",
        "DOCUMENTS": "文档"
      },
      "LINKS": {
        "DOCS": {
          "TITLE": "Captain docs",
          "DESCRIPTION": "Guides and how-tos for Captain"
        },
        "PLAYGROUND": {
          "TITLE": "试验场",
          "DESCRIPTION": "Test this assistant's replies"
        },
        "BILLING": {
          "TITLE": "计费",
          "DESCRIPTION": "Manage credits and plan"
        }
      }
    },
    "ASSISTANT_SWITCHER": {
      "ASSISTANTS": "助手",
      "SWITCH_ASSISTANT": "在助手之间切换",
      "NEW_ASSISTANT": "创建助手",
      "EMPTY_LIST": "未找到助手，请创建一个以开始使用"
    },
    "COPILOT": {
      "TITLE": "Copilot",
      "TRY_THESE_PROMPTS": "尝试这些提示信息",
      "PANEL_TITLE": "开始使用 Copilot",
      "KICK_OFF_MESSAGE": "需要快速摘要、回顾过往对话，或是优化回复内容？Copilot 可助您一臂之力，全面提升工作效率。",
      "SEND_MESSAGE": "发送消息...",
      "EMPTY_MESSAGE": "生成响应时出错。请重试。",
      "LOADER": "Captain 正在思考",
      "YOU": "您",
      "USE": "使用此",
      "RESET": "重置",
      "SHOW_STEPS": "显示步骤",
      "SELECT_ASSISTANT": "选择助手",
      "PROMPTS": {
        "SUMMARIZE": {
          "LABEL": "总结此对话",
          "CONTENT": "总结客户与客服的对话要点，涵盖客户的主要疑虑、问题，以及客服给出的解决方案或回应"
        },
        "SUGGEST": {
          "LABEL": "建议回答",
          "CONTENT": "分析客户的咨询，并起草一份有效回应其关切或问题的回复。确保回复内容清晰、简明，并提供有用的信息。"
        },
        "RATE": {
          "LABEL": "为此对话评分",
          "CONTENT": "请审核对话，评估其在多大程度上满足了客户的需求。根据语气、清晰度和有效性进行 5 分制评分。"
        },
        "HIGH_PRIORITY": {
          "LABEL": "高优先级对话",
          "CONTENT": "请给我所有高优先级未结对话的摘要。包括对话 ID、客户姓名（如有）、最后一条消息内容和分配的客服人员。如有需要，请按状态分组。"
        },
        "LIST_CONTACTS": {
          "LABEL": "列出联系人",
          "CONTENT": "显示我的前 10 位联系人列表。包括姓名、电子邮件或电话号码（如有）、最后在线时间、标签（如有）。"
        }
      }
    },
    "PLAYGROUND": {
      "USER": "您",
      "ASSISTANT": "助手",
      "MESSAGE_PLACEHOLDER": "输入您的消息...",
      "HEADER": "试验场",
      "DESCRIPTION": "使用此试验场向您的助手发送消息，并检查其是否能够准确、快速地以您期望的语气做出回应。",
      "CREDIT_NOTE": "这里发送的消息将计入您的 Captain 积分。"
    },
    "PAYWALL": {
      "TITLE": "升级以使用 Captain AI",
      "AVAILABLE_ON": "Captain 在免费计划中不可用。",
      "UPGRADE_PROMPT": "升级您的计划以获取我们的助手、副驾驶等功能。",
      "UPGRADE_NOW": "立即升级",
      "CANCEL_ANYTIME": "您可以随时更改或取消您的计划"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI 仅适用于企业计划。",
      "UPGRADE_PROMPT": "升级您的计划以获取我们的助手、副驾驶等功能。",
      "ASK_ADMIN": "请联系您的管理员进行升级。"
    },
    "BANNER": {
      "RESPONSES": "您已使用超过 80% 的回复限制。要继续使用 Captain AI，请升级。",
      "DOCUMENTS": "文档限制已满。升级以继续使用 Captain AI。"
    },
    "FORM": {
      "CANCEL": "取消",
      "CREATE": "创建",
      "EDIT": "更新"
    },
    "ASSISTANTS": {
      "HEADER": "助手",
      "NO_ASSISTANTS_AVAILABLE": "您的帐户中没有可用的助手。",
      "ADD_NEW": "创建新的助手",
      "DELETE": {
        "TITLE": "您确定要删除该文档吗？",
        "DESCRIPTION": "此操作是永久性的。删除此文档将永久删除所有生成的知识。",
        "CONFIRM": "是，删除",
        "SUCCESS_MESSAGE": "文档已成功删除",
        "ERROR_MESSAGE": "删除文档时出错，请重试。"
      },
      "FORM_DESCRIPTION": "填写以下详细信息以命名您的助手，描述其用途，并指定它将支持的产品。",
      "CREATE": {
        "TITLE": "创建助手",
        "SUCCESS_MESSAGE": "助手已成功创建",
        "ERROR_MESSAGE": "创建助手时出错，请重试。"
      },
      "FORM": {
        "UPDATE": "更新",
        "SECTIONS": {
          "BASIC_INFO": "基本信息",
          "SYSTEM_MESSAGES": "系统消息",
          "INSTRUCTIONS": "指令",
          "FEATURES": "特性",
          "TOOLS": "工具 "
        },
        "NAME": {
          "LABEL": "姓名：",
          "PLACEHOLDER": "输入助手名称",
          "ERROR": "名称是必需的"
        },
        "DESCRIPTION": {
          "LABEL": "描述信息",
          "PLACEHOLDER": "输入助手描述",
          "ERROR": "描述是必需的"
        },
        "PRODUCT_NAME": {
          "LABEL": "产品名称",
          "PLACEHOLDER": "输入产品名称",
          "ERROR": "产品名称是必需的"
        },
        "WELCOME_MESSAGE": {
          "LABEL": "欢迎消息",
          "PLACEHOLDER": "输入欢迎消息"
        },
        "HANDOFF_MESSAGE": {
          "LABEL": "交接信息",
          "PLACEHOLDER": "输入交接消息"
        },
        "RESOLUTION_MESSAGE": {
          "LABEL": "解决消息",
          "PLACEHOLDER": "输入解决消息"
        },
        "INSTRUCTIONS": {
          "LABEL": "指令",
          "PLACEHOLDER": "输入用于此助手的指令"
        },
        "FEATURES": {
          "TITLE": "特性",
          "ALLOW_CONVERSATION_FAQS": "从已解决的对话中生成常见问题",
          "ALLOW_MEMORIES": "从客户互动中捕获关键细节作为记忆",
          "ALLOW_CITATIONS": "Include source citations in responses",
          "ALLOW_CONTACT_ATTRIBUTES": "Allow access to contact information"
        }
      },
      "EDIT": {
        "TITLE": "更新助手",
        "SUCCESS_MESSAGE": "助手已成功更新",
        "ERROR_MESSAGE": "更新助手时出错，请重试",
        "NOT_FOUND": "无法找到助手。请重试。"
      },
      "SETTINGS": {
        "HEADER": "设置",
        "BASIC_SETTINGS": {
          "TITLE": "基本设置",
          "DESCRIPTION": "Customize what the assistant says when ending a conversation or transferring to a human."
        },
        "SYSTEM_SETTINGS": {
          "TITLE": "系统设置",
          "DESCRIPTION": "Customize what the assistant says when ending a conversation or transferring to a human."
        },
        "CONTROL_ITEMS": {
          "TITLE": "The Fun Stuff",
          "DESCRIPTION": "Add more control to the assistant. (a bit more visual like a story : Query guardrail → scenarios → output) Nudges user to actually utilise these.",
          "OPTIONS": {
            "GUARDRAILS": {
              "TITLE": "Guardrails",
              "DESCRIPTION": "Keeps things on track—only the kinds of questions you want your assistant to answer, nothing off-limits or off-topic."
            },
            "RESPONSE_GUIDELINES": {
              "TITLE": "Response guidelines",
              "DESCRIPTION": "The vibe and structure of your assistant’s replies—clear and friendly? Short and snappy? Detailed and formal?"
            }
          }
        },
        "DELETE": {
          "TITLE": "删除助手",
          "DESCRIPTION": "此操作是永久性的。删除此文档将永久删除所有生成的知识。",
          "BUTTON_TEXT": "删除 {assistantName}"
        }
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "编辑助手",
        "DELETE_ASSISTANT": "删除助手",
        "VIEW_CONNECTED_INBOXES": "查看连接的收件箱"
      },
      "EMPTY_STATE": {
        "TITLE": "没有可用的文档",
        "SUBTITLE": "文档用于为您的助手生成常见问题。您可以导入文档以为您的助手提供上下文。",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "助理队长",
          "NOTE": "助理队长直接与客户互动，从您的帮助文档和过去的对话中学习，并提供即时、准确的回复。它处理初始查询，快速解决问题，在需要时再转接给客服人员。"
        }
      },
      "GUARDRAILS": {
        "TITLE": "Guardrails",
        "DESCRIPTION": "Keeps things on track—only the kinds of questions you want your assistant to answer, nothing off-limits or off-topic.",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "全选 ({count})",
          "UNSELECT_ALL": "取消全选({count})",
          "BULK_DELETE_BUTTON": "删除"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example guardrails",
            "ADD": "添加全部",
            "ADD_SINGLE": "Add this",
            "SAVE": "添加并保存",
            "PLACEHOLDER": "Type in another guardrail..."
          },
          "NEW": {
            "TITLE": "Add a guardrail",
            "CREATE": "创建",
            "CANCEL": "取消",
            "PLACEHOLDER": "Type in another guardrail...",
            "TEST_ALL": "测试全部"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "搜索……"
        },
        "EMPTY_MESSAGE": "No guardrails found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No guardrails found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Guardrails added successfully",
            "ERROR": "There was an error adding guardrails, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Guardrails updated successfully",
            "ERROR": "There was an error updating guardrails, please try again."
          },
          "DELETE": {
            "SUCCESS": "Guardrails deleted successfully",
            "ERROR": "There was an error deleting guardrails, please try again."
          }
        }
      },
      "RESPONSE_GUIDELINES": {
        "TITLE": "Response Guidelines",
        "DESCRIPTION": "The vibe and structure of your assistant’s replies—clear and friendly? Short and snappy? Detailed and formal?",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "全选 ({count})",
          "UNSELECT_ALL": "取消全选({count})",
          "BULK_DELETE_BUTTON": "删除"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example response guidelines",
            "ADD": "添加全部",
            "ADD_SINGLE": "Add this",
            "SAVE": "添加并保存",
            "PLACEHOLDER": "Type in another response guideline..."
          },
          "NEW": {
            "TITLE": "Add a response guideline",
            "CREATE": "创建",
            "CANCEL": "取消",
            "PLACEHOLDER": "Type in another response guideline...",
            "TEST_ALL": "测试全部"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "搜索……"
        },
        "EMPTY_MESSAGE": "No response guidelines found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No response guidelines found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Response Guidelines added successfully",
            "ERROR": "There was an error adding response guidelines, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Response Guidelines updated successfully",
            "ERROR": "There was an error updating response guidelines, please try again."
          },
          "DELETE": {
            "SUCCESS": "Response Guidelines deleted successfully",
            "ERROR": "There was an error deleting response guidelines, please try again."
          }
        }
      },
      "SCENARIOS": {
        "TITLE": "Scenarios",
        "DESCRIPTION": "Give your assistant some context—like “what to do when a user is stuck,” or “how to act during a refund request.”",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "全选 ({count})",
          "UNSELECT_ALL": "取消全选({count})",
          "BULK_DELETE_BUTTON": "删除"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example scenarios",
            "ADD": "添加全部",
            "ADD_SINGLE": "Add this",
            "TOOLS_USED": "Tools used :"
          },
          "NEW": {
            "CREATE": "Add a scenario",
            "TITLE": "Create a scenario",
            "FORM": {
              "TITLE": {
                "LABEL": "标题",
                "PLACEHOLDER": "Enter a name for the scenario",
                "ERROR": "Scenario name is required"
              },
              "DESCRIPTION": {
                "LABEL": "描述信息",
                "PLACEHOLDER": "Describe how and where this scenario will be used",
                "ERROR": "Scenario description is required"
              },
              "INSTRUCTION": {
                "LABEL": "How to handle",
                "PLACEHOLDER": "Describe how and where this scenario will be handled",
                "ERROR": "Scenario content is required"
              },
              "CREATE": "创建",
              "CANCEL": "取消"
            }
          }
        },
        "UPDATE": {
          "CANCEL": "取消",
          "UPDATE": "Update changes"
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "搜索……"
        },
        "EMPTY_MESSAGE": "No scenarios found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No scenarios found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Scenarios added successfully",
            "ERROR": "There was an error adding scenarios, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Scenarios updated successfully",
            "ERROR": "There was an error updating scenarios, please try again."
          },
          "DELETE": {
            "SUCCESS": "Scenarios deleted successfully",
            "ERROR": "There was an error deleting scenarios, please try again."
          }
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "文档",
      "ADD_NEW": "创建新文档",
      "FAQ_COUNT": "{n} FAQ | {n} FAQs",
      "SELECTED": "{count} 已选择",
      "SELECT_ALL": "全选 ({count})",
      "UNSELECT_ALL": "取消全选({count})",
      "BULK_DELETE_BUTTON": "删除",
      "BULK_SYNC_BUTTON": "刷新",
      "BULK_DELETE": {
        "TITLE": "Delete documents?",
        "DESCRIPTION": "Are you sure you want to delete the selected documents? This action cannot be undone.",
        "CONFIRM": "是，全部删除",
        "SUCCESS_MESSAGE": "Documents deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the documents, please try again."
      },
      "BULK_SYNC": {
        "SUCCESS_MESSAGE_ONE": "Refresh queued for 1 document",
        "SUCCESS_MESSAGE": "Refresh queued for {count} documents",
        "ZERO_MESSAGE": "No documents marked for refresh.",
        "ERROR_MESSAGE": "There was an error queuing the refresh, please try again."
      },
      "SYNC": {
        "QUEUED_MESSAGE": "Refresh queued. We'll update the document shortly.",
        "ERROR_MESSAGE": "Could not queue refresh, please try again."
      },
      "FILTERS": {
        "SOURCE": {
          "ALL": "All sources",
          "WEB": "Web pages",
          "PDF": "PDFs"
        },
        "STATUS": {
          "ANY": "Any status",
          "UPDATED": "Updated",
          "NEEDS_UPDATE": "Needs update",
          "UPDATING": "Updating",
          "FAILED": "失败"
        },
        "SORT": {
          "RECENTLY_UPDATED": "Recently updated",
          "RECENTLY_CREATED": "Recently created"
        },
        "SEARCH_PLACEHOLDER": "搜索……"
      },
      "SYNC_STATUS": {
        "SYNCED": "last updated {time}",
        "SYNCING": "更新中……",
        "STALE_SYNC": "update stalled",
        "FAILED": "Failed to sync",
        "NEVER_SYNCED": "not updated yet"
      },
      "SYNC_ERRORS": {
        "NOT_FOUND": "页面不存在",
        "ACCESS_DENIED": "Access denied",
        "TIMEOUT": "Page took too long to respond",
        "CONTENT_EMPTY": "Page returned empty content",
        "FETCH_FAILED": "Could not fetch page",
        "SYNC_ERROR": "Unexpected error",
        "DEFAULT": "Sync error"
      },
      "RELATED_RESPONSES": {
        "TITLE": "相关常见问题",
        "EMPTY": "No FAQs have been generated from this document yet."
      },
      "DETAILS": {
        "DESCRIPTION": "Review the crawled content and the FAQs generated from this source.",
        "SOURCE": "Source",
        "GENERATED_FAQS": "Generated FAQs",
        "LAST_UPDATED": "Last updated",
        "NOT_AVAILABLE": "暂无",
        "CONTENT_TAB": "Crawled content",
        "PDF_TAB": "PDF details",
        "CONTENT_TITLE": "Crawled content",
        "PDF_TITLE": "PDF file",
        "PDF_DESCRIPTION": "Review the original PDF source.",
        "CHARACTER_COUNT": "{count} characters extracted",
        "COPY_CONTENT": "复制",
        "COPY_SUCCESS": "Crawled content copied to clipboard",
        "COPY_ERROR": "Could not copy crawled content",
        "VIEW_RAW": "View raw",
        "VIEW_PREVIEW": "View preview",
        "UNREADABLE_CONTENT": "Readable content could not be extracted from this document. You can view the raw extracted content.",
        "EMPTY_CONTENT": "No crawled content is available for this document yet."
      },
      "FORM_DESCRIPTION": "输入文档的 URL 以将其添加为知识源，并选择要关联的助手。",
      "CREATE": {
        "TITLE": "添加文档",
        "SUCCESS_MESSAGE": "文档已成功创建",
        "ERROR_MESSAGE": "创建文档时出错，请重试"
      },
      "FORM": {
        "TYPE": {
          "LABEL": "Document Type",
          "URL": "网址",
          "PDF": "PDF 文件"
        },
        "URL": {
          "LABEL": "网址",
          "PLACEHOLDER": "输入文档的 URL",
          "ERROR": "请提供有效的文档 URL"
        },
        "PDF_FILE": {
          "LABEL": "PDF 文件",
          "CHOOSE_FILE": "选择 PDF 文件",
          "ERROR": "请选择一个 PDF 文件",
          "HELP_TEXT": "最大文件大小: 10MB",
          "INVALID_TYPE": "请选择一个有效的 PDF 文件",
          "TOO_LARGE": "文件大小超过 10MB 限制"
        },
        "NAME": {
          "LABEL": "文档名称(可选)",
          "PLACEHOLDER": "输入文档的名称"
        }
      },
      "DELETE": {
        "TITLE": "您确定要删除该文档吗？",
        "DESCRIPTION": "此操作是永久性的。删除此文档将永久删除所有生成的知识。",
        "CONFIRM": "是，删除",
        "SUCCESS_MESSAGE": "文档已成功删除",
        "ERROR_MESSAGE": "删除文档时出错，请重试"
      },
      "OPTIONS": {
        "VIEW_DETAILS": "查看详细信息",
        "SYNC_NOW": "Refresh now",
        "RETRY_SYNC": "Retry refresh",
        "DELETE_DOCUMENT": "删除文档"
      },
      "EMPTY_STATE": {
        "TITLE": "没有可用的文档",
        "SUBTITLE": "文档用于为您的助手生成常见问题。您可以导入文档以为您的助手提供上下文。",
        "FILTERED_TITLE": "No matching documents",
        "FILTERED_SUBTITLE": "Try changing the source, status, or search term.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain 文档",
          "NOTE": "在 Captain 中的文档作为助理的知识资源。通过连接您的帮助中心或指南，Captain 可以分析内容并为客户询问提供准确的回答。"
        }
      }
    },
    "CUSTOM_TOOLS": {
      "HEADER": "工具",
      "ADD_NEW": "Create a new tool",
      "SOFT_LIMIT_WARNING": "Having more than 10 tools may reduce the assistant's reliability in selecting the right tool. Consider removing unused tools for better results.",
      "EMPTY_STATE": {
        "TITLE": "No custom tools available",
        "SUBTITLE": "Create custom tools to connect your assistant with external APIs and services, enabling it to fetch data and perform actions on your behalf.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Custom Tools",
          "NOTE": "Custom tools allow your assistant to interact with external APIs and services. Create tools to fetch data, perform actions, or integrate with your existing systems to enhance your assistant's capabilities."
        }
      },
      "FORM_DESCRIPTION": "Configure your custom tool to connect with external APIs",
      "OPTIONS": {
        "EDIT_TOOL": "Edit tool",
        "DELETE_TOOL": "Delete tool"
      },
      "CREATE": {
        "TITLE": "Create Custom Tool",
        "SUCCESS_MESSAGE": "Custom tool created successfully",
        "ERROR_MESSAGE": "Failed to create custom tool"
      },
      "EDIT": {
        "TITLE": "Edit Custom Tool",
        "SUCCESS_MESSAGE": "Custom tool updated successfully",
        "ERROR_MESSAGE": "Failed to update custom tool"
      },
      "DELETE": {
        "TITLE": "Delete Custom Tool",
        "DESCRIPTION": "Are you sure you want to delete this custom tool? This action cannot be undone.",
        "CONFIRM": "是的，删除",
        "SUCCESS_MESSAGE": "Custom tool deleted successfully",
        "ERROR_MESSAGE": "Failed to delete custom tool"
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use tools with Captain",
        "AVAILABLE_ON": "Captain Tools are only available in Business and Enterprise plans. Please upgrade to Business plan to use the feature.",
        "UPGRADE_PROMPT": "",
        "UPGRADE_NOW": "查看计费",
        "CANCEL_ANYTIME": ""
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "Captain Tools are only available in the paid plans.",
        "UPGRADE_PROMPT": "Please upgrade to a paid plan to use this feature.",
        "ASK_ADMIN": "请联系您的管理员进行升级。"
      },
      "TEST": {
        "BUTTON": "Test connection",
        "SUCCESS": "Endpoint returned HTTP {status}",
        "ERROR": "Connection failed",
        "DISABLED_HINT": "Testing is only available for endpoints without templates or request bodies."
      },
      "FORM": {
        "TITLE": {
          "LABEL": "Tool Name",
          "PLACEHOLDER": "Order Lookup",
          "ERROR": "Tool name is required",
          "MAX_LENGTH_ERROR": "Tool name must be {max} characters or fewer"
        },
        "DESCRIPTION": {
          "LABEL": "描述信息",
          "PLACEHOLDER": "Looks up order details by order ID"
        },
        "HTTP_METHOD": {
          "LABEL": "Method"
        },
        "ENDPOINT_URL": {
          "LABEL": "Endpoint URL",
          "PLACEHOLDER": "https://api.example.com/orders/{'{{'} order_id {'}}'}",
          "ERROR": "Valid URL is required"
        },
        "AUTH_TYPE": {
          "LABEL": "Authentication Type"
        },
        "AUTH_TYPES": {
          "NONE": "啥都没有",
          "BEARER": "Bearer Token",
          "BASIC": "Basic Auth",
          "API_KEY": "API 密钥"
        },
        "AUTH_CONFIG": {
          "BEARER_TOKEN": "Bearer Token",
          "BEARER_TOKEN_PLACEHOLDER": "Enter your bearer token",
          "USERNAME": "Username",
          "USERNAME_PLACEHOLDER": "Enter username",
          "PASSWORD": "密码",
          "PASSWORD_PLACEHOLDER": "Enter password",
          "API_KEY": "Header Name",
          "API_KEY_PLACEHOLDER": "X-API-Key",
          "API_VALUE": "Header Value",
          "API_VALUE_PLACEHOLDER": "Enter API key value"
        },
        "PARAMETERS": {
          "LABEL": "Parameters",
          "HELP_TEXT": "Define the parameters that will be extracted from user queries"
        },
        "ADD_PARAMETER": "Add Parameter",
        "PARAM_NAME": {
          "PLACEHOLDER": "Parameter name (e.g., order_id)"
        },
        "PARAM_TYPE": {
          "PLACEHOLDER": "类型"
        },
        "PARAM_TYPES": {
          "STRING": "String",
          "NUMBER": "号码",
          "BOOLEAN": "Boolean",
          "ARRAY": "Array",
          "OBJECT": "Object"
        },
        "PARAM_DESCRIPTION": {
          "PLACEHOLDER": "Description of the parameter"
        },
        "PARAM_REQUIRED": {
          "LABEL": "必填项"
        },
        "REQUEST_TEMPLATE": {
          "LABEL": "Request Body Template (Optional)",
          "PLACEHOLDER": "{'{'}\n  \"order_id\": \"{'{{'} order_id {'}}'}\"\n{'}'}"
        },
        "RESPONSE_TEMPLATE": {
          "LABEL": "Response Template (Optional)",
          "PLACEHOLDER": "Order {'{{'} order_id {'}}'} status: {'{{'} status {'}}'}"
        },
        "ERRORS": {
          "PARAM_NAME_REQUIRED": "Parameter name is required"
        }
      }
    },
    "RESPONSES": {
      "HEADER": "常见问题",
      "PENDING_FAQS": "Pending FAQs",
      "ADD_NEW": "创建新常见问题",
      "DOCUMENTABLE": {
        "CONVERSATION": "对话 #{id}"
      },
      "SELECTED": "{count} 已选择",
      "SELECT_ALL": "全选 ({count})",
      "UNSELECT_ALL": "取消全选({count})",
      "SEARCH_PLACEHOLDER": "搜索常见问题...",
      "BULK_APPROVE_BUTTON": "批准",
      "BULK_DELETE_BUTTON": "删除",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "常见问题已成功批准",
        "ERROR_MESSAGE": "批准常见问题时出错，请重试"
      },
      "BULK_DELETE": {
        "TITLE": "删除常见问题？",
        "DESCRIPTION": "您确定要删除选中的常见问题吗？此操作无法撤销。",
        "CONFIRM": "是，全部删除",
        "SUCCESS_MESSAGE": "常见问题已成功删除",
        "ERROR_MESSAGE": "删除常见问题时出错，请重试"
      },
      "DELETE": {
        "TITLE": "您确定要删除该常见问题吗？",
        "DESCRIPTION": "",
        "CONFIRM": "是，删除",
        "SUCCESS_MESSAGE": "常见问题已成功删除",
        "ERROR_MESSAGE": "删除常见问题时出错，请重试"
      },
      "FILTER": {
        "ASSISTANT": "助手：{selected}",
        "STATUS": "状态：{selected}",
        "ALL_ASSISTANTS": "所有"
      },
      "STATUS": {
        "TITLE": "状态",
        "PENDING": "待处理",
        "APPROVED": "已批准",
        "ALL": "所有"
      },
      "PENDING_BANNER": {
        "TITLE": "Captain has found some FAQs your customers were looking for.",
        "ACTION": "Click here to review"
      },
      "FORM_DESCRIPTION": "将问题及其对应的答案添加到知识库，并选择应关联的助手。",
      "CREATE": {
        "TITLE": "添加常见问题",
        "SUCCESS_MESSAGE": "响应已成功添加",
        "ERROR_MESSAGE": "添加响应时出错，请重试"
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "问题",
          "PLACEHOLDER": "在此输入问题",
          "ERROR": "请提供有效的问题"
        },
        "ANSWER": {
          "LABEL": "答案",
          "PLACEHOLDER": "在此输入答案",
          "ERROR": "请提供有效的答案"
        }
      },
      "EDIT": {
        "TITLE": "更新常见问题",
        "SUCCESS_MESSAGE": "常见问题已成功更新",
        "ERROR_MESSAGE": "更新常见问题时出错，请重试",
        "APPROVE_SUCCESS_MESSAGE": "常见问题已标记为已批准"
      },
      "OPTIONS": {
        "APPROVE": "批准",
        "EDIT_RESPONSE": "编辑",
        "DELETE_RESPONSE": "删除"
      },
      "EMPTY_STATE": {
        "TITLE": "未找到常见问题",
        "NO_PENDING_TITLE": "There are no more pending FAQs to review",
        "SUBTITLE": "常见问题帮助您的助手为客户提供快速准确的答案。它们可以从您的内容自动生成，也可以手动添加。",
        "CLEAR_SEARCH": "Clear active filters",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain 常见问题",
          "NOTE": "Captain FAQs 检测常见的客户问题——无论是知识库中缺失的问题还是经常被问到的问题——并生成相关的常见问题以改善支持。您可以查看每个建议，并决定是否批准或拒绝它。"
        }
      }
    },
    "INBOXES": {
      "HEADER": "连接的收件箱",
      "ADD_NEW": "连接新收件箱",
      "OPTIONS": {
        "DISCONNECT": "断开连接"
      },
      "DELETE": {
        "TITLE": "您确定要断开收件箱的连接吗？",
        "DESCRIPTION": "",
        "CONFIRM": "是，删除",
        "SUCCESS_MESSAGE": "收件箱已成功断开连接",
        "ERROR_MESSAGE": "断开收件箱连接时出错，请重试"
      },
      "FORM_DESCRIPTION": "选择要与助手连接的收件箱。",
      "CREATE": {
        "TITLE": "连接收件箱",
        "SUCCESS_MESSAGE": "收件箱已成功连接",
        "ERROR_MESSAGE": "连接收件箱时出错，请重试"
      },
      "FORM": {
        "INBOX": {
          "LABEL": "收件箱",
          "PLACEHOLDER": "选择收件箱以部署助手",
          "ERROR": "需要选择收件箱"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "没有连接的收件箱",
        "SUBTITLE": "连接收件箱允许助手在处理客户初始问题后将对话转交给您。"
      }
    }
  }
}
